import { ForwardedRef } from 'react'

import { RangeStyle } from './VideoPlayer.utils.types'

const VOLUME_CURVE_EXPONENT = 2

const clampUnitValue = (value: number) => Math.min(1, Math.max(0, value))

export const setForwardedVideoRef = (
  ref: ForwardedRef<HTMLVideoElement>,
  element: HTMLVideoElement | null
) => {
  if (typeof ref === 'function') {
    ref(element)
  } else if (ref) {
    ref.current = element
  }
}

export const formatVideoTime = (seconds: number) => {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00'

  const roundedSeconds = Math.floor(seconds)
  const hours = Math.floor(roundedSeconds / 3600)
  const minutes = Math.floor((roundedSeconds % 3600) / 60)
  const remainingSeconds = roundedSeconds % 60

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(
      remainingSeconds
    ).padStart(2, '0')}`
  }

  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`
}

export const getRangeStyle = (percentage: number) =>
  ({
    '--range-value': `${Math.min(100, Math.max(0, percentage))}%`
  }) as RangeStyle

export const sliderPositionToVolume = (position: number) =>
  Math.pow(clampUnitValue(position), VOLUME_CURVE_EXPONENT)

export const volumeToSliderPosition = (volume: number) =>
  Math.pow(clampUnitValue(volume), 1 / VOLUME_CURVE_EXPONENT)
